import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52f07631"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "column-cell",
  style: {"display":"flex","flex-flow":"row","align-items":"center"}
}
const _hoisted_2 = { class: "column-cell" }
const _hoisted_3 = { class: "column-cell" }
const _hoisted_4 = { style: {"display":"flex","flex-direction":"row"} }
const _hoisted_5 = { class: "p-ml-sm-0 p-ml-md-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-my-1 p-pl-2" }, "Felder", -1))
const _hoisted_7 = {
  class: "recordTable",
  style: {"height":"min-content"}
}
const _hoisted_8 = { class: "p-text-bold p-p-2" }
const _hoisted_9 = { class: "p-ml-sm-0 p-ml-md-6" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-my-1 p-pl-2" }, "Metadaten", -1))
const _hoisted_11 = {
  class: "recordTable",
  style: {"height":"min-content"}
}
const _hoisted_12 = { class: "p-text-bold p-p-2" }
const _hoisted_13 = { class: "p-ml-sm-0 p-ml-md-6" }
const _hoisted_14 = { class: "p-my-1" }
const _hoisted_15 = { style: {"list-style-type":"none"} }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["onMouseover", "onClick"]
const _hoisted_19 = { key: 2 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = ["download", "href"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = ["src"]
const _hoisted_24 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_DownloadHitList = _resolveComponent("DownloadHitList")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataTable, {
      value: _ctx.records,
      loading: _ctx.loading,
      class: "p-shadow-2 p-datatable-documents p-datatable-sm",
      lazy: true,
      scrollable: true,
      scrollHeight: "flex",
      paginator: true,
      expandedRows: _ctx.expandedRows,
      "onUpdate:expandedRows": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.expandedRows) = $event)),
      selection: _ctx.selection,
      "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selection) = $event)),
      rows: _ctx.pagination.pageSize,
      totalRecords: _ctx.totalSize,
      onSort: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSort($event))),
      onPage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPage($event))),
      onRowClick: _ctx.onRowClick,
      onRowExpand: _ctx.onRowExpand,
      onRowCollapse: _ctx.onRowCollapse,
      onFilter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onFilter($event.filters))),
      filters: _ctx.filters,
      "onUpdate:filters": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters) = $event)),
      filterDisplay: "row",
      rowHover: true,
      removableSort: true,
      first: (_ctx.firstEntry),
      paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
      currentPageReportTemplate: '{first} ' + _ctx.$t('Squeeze.General.To') + ' {last} ' + _ctx.$t('Squeeze.General.Of') + ' {totalRecords} ',
      rowsPerPageOptions: [25,50,100]
    }, {
      loading: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.Loading')), 1)
      ]),
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.NoEntriesFound', { entryName: _ctx.$t('Freeze.SearchMask.Entries') })), 1)
      ]),
      expansion: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("table", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.data.recordFields, (value, name) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: name,
                  class: "p-p-2"
                }, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(name) + ": ", 1),
                  _createElementVNode("td", null, _toDisplayString(value), 1)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("table", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.data.headerFields, (value, name) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: name,
                  class: "p-p-2"
                }, [
                  _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.$t(`Freeze.Eas.HeaderFields.${name}`)) + ": ", 1),
                  _createElementVNode("td", null, _toDisplayString(value), 1)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h2", _hoisted_14, _toDisplayString(_ctx.$t('Freeze.SearchMask.Attachments')), 1),
            _createElementVNode("ul", _hoisted_15, [
              ((!slotProps.data.attachments || slotProps.data.attachments.length === 0) && !slotProps.data.attachmentsLoading)
                ? (_openBlock(), _createElementBlock("li", _hoisted_16, _toDisplayString(_ctx.$t('Freeze.SearchMask.NoResults')), 1))
                : _createCommentVNode("", true),
              (slotProps.data.attachmentsLoading)
                ? (_openBlock(), _createElementBlock("li", _hoisted_17, _toDisplayString(_ctx.$t('Freeze.SearchMask.Loading')), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.data.attachments, (attachment) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: attachment.id,
                  onMouseover: ($event: any) => (_ctx.onMouseOverAttachment(slotProps.data, attachment.documentBase64, attachment.name)),
                  onClick: ($event: any) => (_ctx.openDocument(attachment.documentBase64, attachment.name )),
                  style: {"cursor":"pointer"}
                }, _toDisplayString(attachment.name) + " (" + _toDisplayString((attachment.size / 1024).toFixed(0)) + " KB)", 41, _hoisted_18))
              }), 128)),
              (slotProps.data.attachments && slotProps.data.attachments.length > 0 && slotProps.data.currentDocumentBase64)
                ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('Freeze.SearchMask.CurrentDocument')) + ": ", 1),
                    _createTextVNode(" " + _toDisplayString(slotProps.data.currentDocumentName) + " (", 1),
                    _createElementVNode("a", {
                      download: slotProps.data.currentDocumentName,
                      href: 'data:;base64, ' + slotProps.data.currentDocumentBase64
                    }, "Download", 8, _hoisted_21),
                    _createTextVNode(")"),
                    _hoisted_22,
                    (slotProps.data.currentDocumentName && slotProps.data.currentDocumentName.toLowerCase().indexOf('.pdf') !== -1)
                      ? (_openBlock(), _createElementBlock("iframe", {
                          key: 0,
                          src: _ctx.createPdfUrlPath(slotProps.data.currentDocumentBase64),
                          height: "500",
                          width: "100%"
                        }, null, 8, _hoisted_23))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('Freeze.SearchMask.NoPreview')), 1)
                        ], 64))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      paginatorstart: _withCtx(() => [
        _withDirectives(_createVNode(_component_Button, {
          type: "button",
          icon: "mdi mdi-refresh",
          class: "p-button-text p-ml-r",
          onClick: _ctx.onReload,
          disabled: _ctx.loading
        }, null, 8, ["onClick", "disabled"]), [
          [_directive_tooltip, _ctx.$t('Squeeze.General.Refresh')]
        ]),
        _withDirectives(_createVNode(_component_Button, {
          type: "button",
          icon: "mdi mdi-filter-variant-remove",
          class: "p-button-text p-ml-r p-mr-2",
          onClick: _ctx.clearSearch,
          disabled: _ctx.loading
        }, null, 8, ["onClick", "disabled"]), [
          [_directive_tooltip, _ctx.$t('Squeeze.General.ClearSearch')]
        ]),
        _createVNode(_component_InputText, {
          style: {"width":"auto"},
          class: "filter-field",
          type: "text",
          value: _ctx.fullText,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emit('update:fullText', $event.target.value))),
          onKeydown: _withKeys(_ctx.onReload, ["enter"]),
          placeholder: _ctx.$t('Squeeze.General.Search') + '...'
        }, null, 8, ["value", "onKeydown", "placeholder"]),
        (_ctx.selection.length === 0)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              type: "button",
              label: _ctx.$t('Freeze.General.DownloadDocuments'),
              icon: "mdi mdi-download",
              class: "p-button-text p-ml-r p-ml-2",
              onClick: _ctx.openDownload,
              disabled: _ctx.loading
            }, null, 8, ["label", "onClick", "disabled"]))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              type: "button",
              label: _ctx.$t('Freeze.General.DownloadSelectedFiles') + ' (' + _ctx.selection.length + ')',
              icon: "mdi mdi-download",
              class: "p-button-text p-ml-r p-ml-2",
              onClick: _ctx.openDownload,
              disabled: _ctx.loading
            }, null, 8, ["label", "onClick", "disabled"]))
      ]),
      paginatorend: _withCtx(() => []),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          selectionMode: "multiple",
          headerClass: "header-center",
          style: {"min-width":"2rem","max-width":"2rem","text-align":"center"}
        }),
        _createVNode(_component_Column, {
          expander: true,
          headerStyle: "width: 3rem",
          style: {"min-width":"4rem","max-width":"4rem"},
          class: "expander"
        }),
        _createVNode(_component_Column, {
          field: "id",
          header: "ID",
          headerStyle: "width: 10rem",
          style: {"min-width":"12rem","max-width":"12rem"},
          sortable: true
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_1, [
              _withDirectives((_openBlock(), _createElementBlock("div", null, [
                _createTextVNode(_toDisplayString(data.id.slice(0, 8)) + " ... ", 1)
              ])), [
                [
                  _directive_tooltip,
                  data.id,
                  void 0,
                  { bottom: true }
                ]
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "headerFields._archiveDateTime",
          header: _ctx.$t('Freeze.SearchMask.Date'),
          style: {"min-width":"20rem"},
          sortable: true
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.formatDate(data.headerFields._archiveDateTime)), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "headerFields._archiverLogin",
          header: _ctx.$t('Freeze.SearchMask.Creator'),
          style: {"min-width":"20rem"},
          sortable: true
        }, null, 8, ["header"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchFields, (column) => {
          return (_openBlock(), _createBlock(_component_Column, {
            field: column.name,
            filterField: '' + column.name,
            header: column.desc,
            key: column.name,
            showFilterMenu: true,
            sortable: true,
            style: 'min-width: 15rem; overflow: hidden;'
          }, {
            body: _withCtx(({ data }) => [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createTextVNode(_toDisplayString(data.recordFields[column.name]), 1)
              ])), [
                [
                  _directive_tooltip,
                  data.recordFields[column.name],
                  void 0,
                  { bottom: true }
                ]
              ])
            ]),
            filter: _withCtx(({filterModel,filterCallback}) => [
              _createVNode(_component_InputText, {
                style: 'min-width: 14rem; max-width: 14rem;',
                class: "filter-field",
                type: "text",
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                placeholder: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
            ]),
            _: 2
          }, 1032, ["field", "filterField", "header"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["value", "loading", "expandedRows", "selection", "rows", "totalRecords", "onRowClick", "onRowExpand", "onRowCollapse", "filters", "first", "currentPageReportTemplate"]),
    _createVNode(_component_Dialog, {
      header: _ctx.currentDocumentName,
      visible: _ctx.showDocument,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showDocument) = $event)),
      modal: true,
      closable: true,
      dismissableMask: true,
      baseZIndex: 1000,
      breakpoints: {'960px': '75vw', '640px': '100vw'},
      style: {width: '50vw', height: '100vh'}
    }, {
      default: _withCtx(() => [
        _createElementVNode("iframe", {
          src: _ctx.createPdfUrlPath(_ctx.currentDocumentBase64),
          height: "100%",
          width: "100%",
          style: {"height":"100vh","width":"100%"}
        }, null, 8, _hoisted_24)
      ]),
      _: 1
    }, 8, ["header", "visible"]),
    _createVNode(_component_Dialog, {
      header: _ctx.$t('Freeze.General.DownloadSelectedFiles'),
      visible: _ctx.showDownload,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showDownload) = $event)),
      modal: true,
      closable: true,
      dismissableMask: true,
      baseZIndex: 1000,
      style: {width: '49.75rem'}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DownloadHitList, {
          searchMaskId: _ctx.searchMaskId,
          selectedEntries: _ctx.selection,
          totalEntries: _ctx.pagination.total,
          "page-size": _ctx.pagination.pageSize,
          onDownloadDocuments: _ctx.downloadDocuments
        }, null, 8, ["searchMaskId", "selectedEntries", "totalEntries", "page-size", "onDownloadDocuments"])
      ]),
      _: 1
    }, 8, ["header", "visible"])
  ], 64))
}